import styled from "@emotion/styled";
import { breakpoints, colors, spacing } from "@/components/design-tokens";

// Main container that holds the entire chat interface
export const ChatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: ${colors.surface};
  overflow: hidden;
`;

// Main content area with scrolling
export const ChatContentArea = styled.div`
  flex: 1;
  padding: ${spacing["3xl"]}px ${spacing["4xl"]}px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100%;
  scrollbar-width: none;
  box-sizing: border-box;
  
  /* Improve scroll behavior */
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
  
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: ${breakpoints.xl - 1}px) {
    padding: ${spacing["2xl"]}px;
  }
  
  @media (max-width: ${breakpoints.md - 1}px) {
    padding: ${spacing.lg}px;
  }
`;

// Container for the answer/response content
export const AnswerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing["3xl"]}px;
  box-sizing: border-box;
`;

// Container for markdown content with proper spacing
export const MarkdownContent = styled.div`
  & > *:first-child {
    margin-top: 0;
  }

  & > *:last-child {
    margin-bottom: 0;
  }

  & > p + p {
    margin-top: ${spacing.lg}px;
  }
`;
